import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('input-with-options', {
  root: {
    variants: {
      size: ['medium'],
    },
  },
  inputContainer: {},
  menuContainer: {
    states: ['directionUp', 'closing', 'empty'],
  },
  dropdownLayout: {},
  drawerContent: {},
  nativeSelectWrapper: {},
  nativeSelect: {},
});
